var map = {
	"./1-1.png": "756e",
	"./1-2.png": "4bae",
	"./1-3.png": "257b",
	"./1-4.png": "af29",
	"./1-5.png": "f4b8",
	"./2-1.png": "c82d",
	"./2-2.png": "9928",
	"./2-3.png": "676b",
	"./2-4.png": "deb3",
	"./2-5.png": "acee",
	"./3-1.png": "246b",
	"./3-2.png": "a49e",
	"./3-3.png": "7170",
	"./3-4.png": "732b",
	"./3-5.png": "608c",
	"./4-1.png": "a681",
	"./4-2.png": "2bc3",
	"./4-3.png": "9ae7",
	"./4-4.png": "189c",
	"./4-5.png": "a3f8",
	"./curved.png": "0c01",
	"./left.png": "3d70",
	"./right.png": "a125"
};


function webpackContext(req) {
	var id = webpackContextResolve(req);
	return __webpack_require__(id);
}
function webpackContextResolve(req) {
	if(!__webpack_require__.o(map, req)) {
		var e = new Error("Cannot find module '" + req + "'");
		e.code = 'MODULE_NOT_FOUND';
		throw e;
	}
	return map[req];
}
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = "5f92";